import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=f20bf396&scoped=true&"
import script from "./ComingSoon.vue?vue&type=script&lang=ts&"
export * from "./ComingSoon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20bf396",
  null
  
)

export default component.exports